import {EventBus} from "@/eventBus";
import _ from "lodash";

let NotifyMixin = {
    data: function () {
        return {
        }
    },
    methods: {
        nOption(title, variant) {
            return {
                title: title,
                autoHideDelay: 5000,
                variant: variant,
                appendToast: true
            };
        },
        NotifyWarning(title, message) {
            this.$bvToast.toast(message, this.nOption(title, 'warning'));
            this.CheckHiddenButton();
        },
        NotifySuccess(title, message) {
            this.$bvToast.toast(message, this.nOption(title, 'success'));
            this.CheckHiddenButton();
        },
        NotifyDanger(title, message) {
            this.$bvToast.toast(message, this.nOption(title, 'danger'));
            this.CheckHiddenButton();
        },
        NotifyInfo(title, message) {
            this.$bvToast.toast(message, this.nOption(title, 'info'));
            this.CheckHiddenButton();
        },
        NotifyEvent(data) {
            if (_.isEmpty(data)) {
                return;
            }
            if (_.isEmpty(data.message)) {
                return;
            }
            let title = "Notify", variant = "info";
            if (!_.isEmpty(data.title)) {
                title = data.title;
            }
            if (!_.isEmpty(data.variant)) {
                variant = data.variant;
            }
            this.$bvToast.toast(data.message, {
                title: title,
                autoHideDelay: 5000,
                variant: variant,
                appendToast: true
            });
            this.CheckHiddenButton();
        },
        CheckHiddenButton() {
            if (document.getElementsByClassName("b-toast-append").length > 2) {
                document.getElementById("toast-hide-all__toast_outer").style.display = "block";
            } else {
                document.getElementById("toast-hide-all__toast_outer").style.display = "none";
            }
        },
        addHideAllBtn() {
            let addHideAllBtn = this.addHideAllBtn;
            //this.$bvToast.hide();
            const hideAll = this.$createElement;
            const vNodesMsgHideAll = hideAll(
                'b-link',
                {
                    attrs: { href: `#` },
                    domProps: { innerHTML: 'HIDE ALL' },
                    on: {
                        click: function() {
                            EventBus.$emit('hide-all-notifies');
                            setTimeout(function () {
                                addHideAllBtn();
                            }, 500);
                        }
                    }
                }
            );
            this.$bvToast.toast([vNodesMsgHideAll], {
                noAutoHide: true,
                variant: 'info',
                toastClass: 'toast-hide-all',
                id: 'toast-hide-all',
                appendToast: true
            });
        },
        hideAll() {
            this.$bvToast.hide();
        },
    },
    created: function () {
        EventBus.$on("event", this.CheckHiddenButton);
        EventBus.$on("hide-all-notifies", this.hideAll);
        EventBus.$on("notify", this.NotifyEvent);
        this.addHideAllBtn();
        window.setInterval(this.CheckHiddenButton, 1600);
    },
    destroyed() {
        EventBus.$off("event", this.CheckHiddenButton);
        EventBus.$off("hide-all-notifies", this.hideAll);
        EventBus.$off("notify", this.NotifyEvent);
    },
};

export {NotifyMixin};